var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.66683H14.6667C14.8877 6.66683 15.0996 6.75463 15.2559 6.91091C15.4122 7.06719 15.5 7.27915 15.5 7.50016V17.5002C15.5 17.7212 15.4122 17.9331 15.2559 18.0894C15.0996 18.2457 14.8877 18.3335 14.6667 18.3335H1.33333C1.11232 18.3335 0.900358 18.2457 0.744078 18.0894C0.587797 17.9331 0.5 17.7212 0.5 17.5002V7.50016C0.5 7.27915 0.587797 7.06719 0.744078 6.91091C0.900358 6.75463 1.11232 6.66683 1.33333 6.66683H3V5.8335C3 4.50741 3.52678 3.23564 4.46447 2.29796C5.40215 1.36028 6.67392 0.833496 8 0.833496C9.32608 0.833496 10.5979 1.36028 11.5355 2.29796C12.4732 3.23564 13 4.50741 13 5.8335V6.66683ZM2.16667 8.3335V16.6668H13.8333V8.3335H2.16667ZM7.16667 11.6668H8.83333V13.3335H7.16667V11.6668ZM3.83333 11.6668H5.5V13.3335H3.83333V11.6668ZM10.5 11.6668H12.1667V13.3335H10.5V11.6668ZM11.3333 6.66683V5.8335C11.3333 4.94944 10.9821 4.10159 10.357 3.47647C9.7319 2.85135 8.88406 2.50016 8 2.50016C7.11594 2.50016 6.2681 2.85135 5.64298 3.47647C5.01786 4.10159 4.66667 4.94944 4.66667 5.8335V6.66683H11.3333Z",
    fill: "#2E2E2E",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/changePassword.e23a9e9d528f8b5f81f8fdef57e76c62.svg";
export { ForwardRef as ReactComponent };